import Dropbox from 'dropbox'

const DropboxInteractions = {
    saveJSONFile: (filePath, fileContent) => {
        let dbx = new Dropbox.Dropbox({ fetch:fetch, accessToken: process.env.REACT_APP_DROPBOX_API_KEY });
        dbx.filesUpload({
            contents: fileContent,
            path: filePath,
            mode: {
                '.tag': 'overwrite',
            },
            autorename: false,
        })
    },
    getJSONFile: async (filePath) => {
        let dbx = new Dropbox.Dropbox({ fetch:fetch, accessToken: process.env.REACT_APP_DROPBOX_API_KEY });
        return dbx.filesDownload({path: filePath});
    },
    createFolder: (path) => {
        let dbx = new Dropbox.Dropbox({ fetch:fetch, accessToken: process.env.REACT_APP_DROPBOX_API_KEY });
        dbx.filesCreateFolderV2({path: path, autorename: false})
    },
    createFolders: (paths) => {
        let dbx = new Dropbox.Dropbox({ fetch:fetch, accessToken: process.env.REACT_APP_DROPBOX_API_KEY });
        dbx.filesCreateFolderBatch({paths: paths, autorename: false, force_async: false})
    },
    deleteFile: (folderPath) => {
        let dbx = new Dropbox.Dropbox({ fetch:fetch, accessToken: process.env.REACT_APP_DROPBOX_API_KEY });
        return dbx.filesDeleteV2({path: folderPath});
    },
    moveFile: (fromPath, toPath) => {
        let dbx = new Dropbox.Dropbox({ fetch:fetch, accessToken: process.env.REACT_APP_DROPBOX_API_KEY });
        dbx.filesMoveV2({from_path: fromPath, to_path: toPath, autorename: false});
    },
    moveFiles: async (entries) => {
        let dbx = new Dropbox.Dropbox({ fetch:fetch, accessToken: process.env.REACT_APP_DROPBOX_API_KEY });
        return await dbx.filesMoveBatchV2({
            entries: entries, 
            autorename: false
        });
    },
    moveFilesCheck: async (asyncJobId) => {
        let dbx = new Dropbox.Dropbox({ fetch:fetch, accessToken: process.env.REACT_APP_DROPBOX_API_KEY });
        return dbx.filesMoveBatchCheckV2({ 
            async_job_id: asyncJobId 
        });
    },
    searchFiles: async (path, query) => {
        let dbx = new Dropbox.Dropbox({ fetch:fetch, accessToken: process.env.REACT_APP_DROPBOX_API_KEY });
        return dbx.filesSearch({
            path: path, 
            query: query,
            start: 0,
            max_results: 1000,
        });
    },
    getTemporaryLink: async (path) => {
        let dbx = new Dropbox.Dropbox({ fetch:fetch, accessToken: process.env.REACT_APP_DROPBOX_API_KEY });
        return dbx.filesGetTemporaryLink({
            path: path
        });
    },
    saveBundleFile: (content) =>  {
        DropboxInteractions.saveJSONFile(`/${process.env.REACT_APP_DROPBOX_BUNDLE_FILE_NAME}`, content);
    },
    saveDataFile: (id, content) =>  {
        DropboxInteractions.saveJSONFile(`/bundle_${id}/data_${id}.json`, content);
    }
}

export default DropboxInteractions;